import PropTypes from "prop-types";
import React from "react";

import { Text, textPropTypes } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import { getAircraftTypeByCarrierCodeAndEquipmentType } from "../aircrafts";

/**
 * PlaneType displays the plane type along with an optional change disclaimer.
 */

export const PlaneType = (props) => {
  const { className, planeType, showChangeDisclaimer = false, textProps } = props;

  return (
    <Text {...getProps()}>
      {typeof planeType === "string" ? planeType : renderPlaneType()}
      {showChangeDisclaimer && ` ${i18n("PlaneType__CHANGE_DISCLAIMER")}`}
    </Text>
  );

  function renderPlaneType() {
    const { carrierCode, equipmentType } = planeType;

    return getAircraftTypeByCarrierCodeAndEquipmentType(carrierCode, equipmentType);
  }

  function getProps() {
    return {
      "aria-label": i18n("PlaneType__INFORMATION_ARIA_LABEL", {
        PLANE_TYPE: planeType,
      }),
      className,
      size: "xlarge",
      textType: "details",
      ...textProps,
    };
  }
};

PlaneType.propTypes = {
  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /**
   * Content that will be rendered inside the component. If a string is passed in, then the content
   * will be rendered as-is.  If an object containing the carrierCode and equipmentType is passed in
   * then these values will be used to index the content from bootstrap data.
   */
  planeType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      carrierCode: PropTypes.string,
      equipmentType: PropTypes.string,
    }),
  ]).isRequired,

  /** Boolean value to show or hide the change disclaimer. */
  showChangeDisclaimer: PropTypes.bool,

  /** Props passed to the underlying Text component. See Text for more details. */
  textProps: PropTypes.shape(textPropTypes),
};
